import React from 'react';
import useFetch from "../../hooks/useFetch";
import Button from '../../components/Button';
import Logo from '../../components/Logo';
import Spinner from '../../components/Spinner';

import './style.scss';
import BackgroundImage from '../../components/BackgroundImage';

function Home() {
  const [contentArray, loading] = useFetch("/pages?acf_format=standard&slug=forside", []);
  const content = contentArray[0]?.acf;

  return loading ? (
    <div className="Home">
      <Spinner size="xlarge" centered />
    </div>
  ) : (
    <BackgroundImage className="Home" content={content}>
      <Logo idPrefix="home-logo" className="Home__logo" />
      <nav className="Home__navigation">
        {content.links && content.links.map(({link, color, size}) => (
          <Button
            key={link.url}
            color={color}
            size={size}
            to={link.url}
            target={link.target}
            className="Home__link"
          >
            {link.title}
          </Button>
        ))}
      </nav>
      <div className="Home__content">
        <h1 className="Home__title">{content.title}</h1>
        {content.description.split("\r\n\r\n").map((paragraph, index) => (
          <p key={paragraph + index} className="Home__text">{paragraph}</p>
        ))}
      </div>
    </BackgroundImage>
  );
}

export default Home;
